import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "px-4 text-start" };
const _hoisted_4 = { class: "px-4 text-start" };
const _hoisted_5 = { class: "px-4 text-start" };
const _hoisted_6 = { class: "px-4 text-start" };
const _hoisted_7 = { class: "px-4 text-start" };
const _hoisted_8 = { class: "px-4 text-start" };
const _hoisted_9 = { class: "px-4 text-start" };
const _hoisted_10 = { class: "px-4 text-start" };
const _hoisted_11 = {
    key: 0,
    class: "sum-row"
};
import { computed, inject, onMounted, reactive, ref, watch, shallowRef } from "vue";
import { ReservationServiceSymbol, ResourceServiceSymbol } from "@/InjectionSymbols";
import { Formatter } from "@/util/Formatter";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResourceBookingsView',
    setup(__props) {
        const resourceService = inject(ResourceServiceSymbol);
        const reservationService = inject(ReservationServiceSymbol);
        const resourceGroups = reactive([]);
        const selectedResourceGroups = ref([]);
        const resources = reactive([]);
        const selectedResources = reactive([]);
        const dateRangeFrom = ref(new Date());
        const dateRangeTo = ref(new Date());
        const reservationAggregates = reactive([]);
        const dataLoaded = ref(false);
        const startLocationFilter = ref("");
        const endLocationFilter = ref("");
        const dateExactFrom = ref(null);
        const dateExactTo = ref(null);
        const startTimeFilter = shallowRef(null);
        const endTimeFilter = shallowRef(null);
        const exportInFlight = ref(false);
        onMounted(() => {
            const today = new Date();
            today.setUTCHours(12, 0, 0, 0);
            dateRangeFrom.value = today;
            const tomorrow = new Date();
            tomorrow.setDate(dateRangeTo.value.getDate() + 1);
            tomorrow.setUTCHours(12, 0, 0, 0);
            dateRangeTo.value = tomorrow;
            resourceService?.loadAllResourceGroups().then(resourceGroupsLoaded);
            resourceService?.loadAllResources().then(resourcesLoaded);
        });
        const tableHeaders = computed(() => {
            let headers = [
                { title: 'Von', align: 'start', sortable: false, key: "dateFrom" },
                { title: 'Bis', align: 'start', sortable: false, key: "dateTo" },
                { title: 'Kunde', align: 'start', sortable: false, key: "customer" },
                { title: 'Notiz', align: 'start', sortable: false, key: "internalRemarks" },
                { title: 'Start', align: 'start', sortable: false, key: "productStartLocationName" },
                { title: 'Ende', align: 'start', sortable: false, key: "productEndLocationName" },
                { title: 'Startzeit', align: 'start', sortable: false, key: "startTime" },
                { title: 'Endzeit', align: 'start', sortable: false, key: "endTime" }
            ];
            let headerObjects = [];
            headers.forEach(value => {
                headerObjects.push({
                    key: value.key + "Filter",
                    children: [value]
                });
            });
            let resourceHeader = [];
            let resourcesForList = getResourcesForList();
            if (resourcesForList != null) {
                resourcesForList.forEach(resource => {
                    resourceHeader.push({
                        title: resource.name,
                        align: 'start',
                        sortable: false,
                        key: resource.name
                    });
                });
            }
            headerObjects.push({
                key: "resourceHeader",
                children: resourceHeader
            });
            return headerObjects;
        });
        const includedResourceIds = computed(() => {
            let ids = [];
            if (selectedResourceGroups.value.length > 0) {
                selectedResourceGroups.value.forEach(resourceGroup => {
                    resourceGroup.resources.forEach(resource => {
                        ids.push(Number(resource.id));
                    });
                });
            }
            if (selectedResources.length > 0) {
                selectedResources.forEach(resource => {
                    ids.push(Number(resource.id));
                });
            }
            return ids.filter((value, index, array) => {
                return array.indexOf(value) === index;
            });
        });
        const filteredAggregates = computed(() => {
            return reservationAggregates.filter(r => {
                return ((!startLocationFilter.value ||
                    r.productStartLocationName === startLocationFilter.value) &&
                    (!endLocationFilter.value ||
                        r.productEndLocationName === endLocationFilter.value) &&
                    (!dateExactFrom.value ||
                        r.dateFrom.getTime() === dateExactFrom.value.getTime()) &&
                    (!dateExactTo.value ||
                        r.dateTo.getTime() === dateExactTo.value.getTime()) &&
                    (!startTimeFilter.value ||
                        (r.startTime && r.startTime.equals(startTimeFilter.value))) &&
                    (!endTimeFilter.value ||
                        (r.endTime && r.endTime.equals(endTimeFilter.value))));
            });
        });
        watch(includedResourceIds, (newValue) => {
            if (includedResourceIds.value.length > 0) {
                resourceService?.loadResourceReservations(reservationsLoaded, newValue, dateRangeFrom.value, dateRangeTo.value);
            }
        });
        function resourceGroupsLoaded(loadedGroups) {
            resourceGroups.length = 0;
            resourceGroups.push(...loadedGroups);
            if (resourceGroups.length > 0) {
                selectedResourceGroups.value = resourceGroups;
            }
        }
        function resourcesLoaded(loadedResources) {
            resources.length = 0;
            resources.push(...loadedResources);
        }
        function reservationsLoaded(loadedReservations) {
            reservationAggregates.length = 0;
            reservationAggregates.push(...loadedReservations);
            dataLoaded.value = true;
        }
        function findReservedQuantityForResource(resource, reservationAggregate) {
            return reservationAggregate.resourceReservations[Number(resource.id)];
        }
        function getReservationsSum(resource, items) {
            return items.reduce((sum, item) => {
                let quantity = findReservedQuantityForResource(resource, item);
                return sum + (quantity ? quantity : 0);
            }, 0);
        }
        function onFilterUpdate() {
            if (!dateRangeFrom.value || !dateRangeTo.value || dateRangeFrom.value > dateRangeTo.value)
                return;
            if (includedResourceIds.value.length > 0) {
                resourceService?.loadResourceReservations(reservationsLoaded, includedResourceIds.value, dateRangeFrom.value, dateRangeTo.value);
            }
        }
        function onSingleResourceSelected(value) {
            selectedResources.length = 0;
            selectedResources.push(...value);
        }
        function onResourceGroupSelected(value) {
            selectedResourceGroups.value = value;
        }
        function getResourcesForList() {
            if (includedResourceIds.value.length == 0) {
                return [];
            }
            return resources.filter(resource => includedResourceIds.value.includes(Number(resource.id)));
        }
        function getExactDateFromValues() {
            const allDates = filteredAggregates.value.map(r => r.dateFrom);
            let uniqueDates = allDates.reduce((unique, date) => {
                const dateExists = unique.some((d) => d.getTime() === date.getTime());
                if (!dateExists) {
                    unique.push(date);
                }
                return unique;
            }, []);
            return uniqueDates;
        }
        function getExactDateToValues() {
            const allDates = filteredAggregates.value.map(r => r.dateTo);
            return allDates.reduce((unique, date) => {
                const dateExists = unique.some((d) => d.getTime() === date.getTime());
                if (!dateExists) {
                    unique.push(date);
                }
                return unique;
            }, []);
        }
        function getStartLocationValues() {
            return [...new Set(filteredAggregates.value.map(r => r.productStartLocationName))];
        }
        function getEndLocationValues() {
            return [...new Set(filteredAggregates.value.map(r => r.productEndLocationName))];
        }
        function getStartTimeValues() {
            const unique = [
                ...new Map(filteredAggregates.value
                    .filter(r => r.startTime)
                    .map(r => [Formatter.time(r.startTime), r.startTime])).values()
            ];
            return unique.sort((a, b) => a.compareTo(b));
        }
        function getEndTimeValues() {
            const unique = [
                ...new Map(filteredAggregates.value
                    .filter(r => r.endTime)
                    .map(r => [Formatter.time(r.endTime), r.endTime])).values()
            ];
            return unique.sort((a, b) => a.compareTo(b));
        }
        function exportTableToPdf() {
            exportInFlight.value = true;
            let params = {
                dateRangeFrom: dateRangeFrom.value,
                dateRangeTo: dateRangeTo.value,
            };
            params.resourceIds = includedResourceIds.value.join(',');
            if (startLocationFilter.value != null && startLocationFilter.value != "")
                params.filterStartLocation = startLocationFilter.value;
            if (endLocationFilter.value != null && endLocationFilter.value != "")
                params.filterEndLocation = endLocationFilter.value;
            if (dateExactFrom.value != null)
                params.dateExactFrom = dateExactFrom.value;
            if (dateExactTo.value != null)
                params.dateExactTo = dateExactTo.value;
            if (startTimeFilter.value != null)
                params.filterStartTime = startTimeFilter.value.toString();
            if (endTimeFilter.value != null)
                params.filterEndTime = endTimeFilter.value.toString();
            reservationService.getReservationsExport(params)
                .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                window.open(URL.createObjectURL(blob));
            }).finally(() => {
                exportInFlight.value = false;
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vc_date_picker = _resolveComponent("vc-date-picker");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_data_table = _resolveComponent("v-data-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, {
                        fluid: true,
                        class: ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, {
                                fluid: true,
                                class: "d-flex justify-space-between pa-0 ma-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "v-col-3 text-h4 text-start pa-0 ma-0" }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                            _createTextVNode(" Einsatz und Abholplan ")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, { class: "d-flex flex-wrap pa-0 ma-0 justify-end w-auto" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_select, {
                                                style: { "min-width": "220px" },
                                                class: "toolbar",
                                                "model-value": selectedResourceGroups.value,
                                                items: resourceGroups,
                                                "item-title": "name",
                                                label: "Resourcen Gruppe",
                                                variant: "outlined",
                                                "return-object": "",
                                                multiple: true,
                                                "onUpdate:modelValue": onResourceGroupSelected,
                                                density: "compact",
                                                "data-cy": "resource-group"
                                            }, null, 8, ["model-value", "items"]),
                                            _createVNode(_component_v_select, {
                                                style: { "min-width": "180px" },
                                                class: "toolbar",
                                                "model-value": selectedResources,
                                                items: resources,
                                                "item-title": "name",
                                                label: "Einzelresource",
                                                variant: "outlined",
                                                multiple: true,
                                                active: true,
                                                "return-object": "",
                                                density: "compact",
                                                "onUpdate:modelValue": onSingleResourceSelected,
                                                "data-cy": "single-resource"
                                            }, null, 8, ["model-value", "items"]),
                                            _createVNode(_component_vc_date_picker, {
                                                class: "toolbar",
                                                modelValue: dateRangeFrom.value,
                                                "onUpdate:modelValue": [
                                                    _cache[0] || (_cache[0] = ($event) => ((dateRangeFrom).value = $event)),
                                                    onFilterUpdate
                                                ],
                                                "update-on-input": false,
                                                "data-cy": "dateRangeFrom"
                                            }, {
                                                default: _withCtx(({ inputValue, inputEvents }) => [
                                                    _createVNode(_component_v_text_field, _mergeProps({
                                                        class: "toolbar",
                                                        "data-cy": "date-from",
                                                        "model-value": inputValue
                                                    }, _toHandlers(inputEvents), {
                                                        variant: "outlined",
                                                        label: "Von",
                                                        density: "compact"
                                                    }), null, 16, ["model-value"])
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue"]),
                                            _createVNode(_component_vc_date_picker, {
                                                class: "toolbar",
                                                modelValue: dateRangeTo.value,
                                                "onUpdate:modelValue": [
                                                    _cache[1] || (_cache[1] = ($event) => ((dateRangeTo).value = $event)),
                                                    onFilterUpdate
                                                ],
                                                "update-on-input": false,
                                                "data-cy": "dateRangeTo"
                                            }, {
                                                default: _withCtx(({ inputValue, inputEvents }) => [
                                                    _createVNode(_component_v_text_field, _mergeProps({
                                                        class: "toolbar",
                                                        "data-cy": "date-to",
                                                        "model-value": inputValue,
                                                        variant: "outlined"
                                                    }, _toHandlers(inputEvents), {
                                                        label: "Bis",
                                                        density: "compact"
                                                    }), null, 16, ["model-value"])
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue"]),
                                            _createVNode(_component_v_btn, {
                                                class: "ma-1",
                                                onClick: exportTableToPdf
                                            }, {
                                                default: _withCtx(() => [
                                                    (!exportInFlight.value)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                                                            _createVNode(_component_v_icon, { icon: "mdi-file-export" }),
                                                            _cache[9] || (_cache[9] = _createTextVNode(" Export "))
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (exportInFlight.value)
                                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                            key: 1,
                                                            indeterminate: true
                                                        }))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_data_table, {
                                "data-cy": "resourceBookingsTable",
                                "items-per-page": 100,
                                items: filteredAggregates.value,
                                headers: tableHeaders.value
                            }, {
                                [`header.dateFromFilter`]: _withCtx(({}) => [
                                    _createVNode(_component_v_select, {
                                        class: "pt-1 pb-1",
                                        modelValue: dateExactFrom.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((dateExactFrom).value = $event)),
                                        items: getExactDateFromValues(),
                                        "item-title": (item) => _unref(Formatter).date(item),
                                        label: "Datum von",
                                        variant: "outlined",
                                        "hide-details": "",
                                        density: "compact",
                                        clearable: true,
                                        active: true,
                                        "return-object": "",
                                        "data-cy": "dateExactFrom"
                                    }, null, 8, ["modelValue", "items", "item-title"])
                                ]),
                                [`header.dateToFilter`]: _withCtx(({}) => [
                                    _createVNode(_component_v_select, {
                                        class: "pt-1 pb-1",
                                        modelValue: dateExactTo.value,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((dateExactTo).value = $event)),
                                        items: getExactDateToValues(),
                                        "item-title": (item) => _unref(Formatter).date(item),
                                        label: "Datum bis",
                                        variant: "outlined",
                                        "hide-details": "",
                                        density: "compact",
                                        clearable: true,
                                        active: true,
                                        "return-object": "",
                                        "data-cy": "dateExactTo"
                                    }, null, 8, ["modelValue", "items", "item-title"])
                                ]),
                                [`header.productStartLocationNameFilter`]: _withCtx(({}) => [
                                    _createVNode(_component_v_select, {
                                        class: "pt-1 pb-1",
                                        modelValue: startLocationFilter.value,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((startLocationFilter).value = $event)),
                                        items: getStartLocationValues(),
                                        "item-title": "name",
                                        label: "Startort",
                                        variant: "outlined",
                                        "hide-details": "",
                                        density: "compact",
                                        clearable: true,
                                        "data-cy": "startLocationFilter"
                                    }, null, 8, ["modelValue", "items"])
                                ]),
                                [`header.productEndLocationNameFilter`]: _withCtx(({}) => [
                                    _createVNode(_component_v_select, {
                                        class: "pt-1 pb-1",
                                        modelValue: endLocationFilter.value,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((endLocationFilter).value = $event)),
                                        items: getEndLocationValues(),
                                        "item-title": "name",
                                        label: "Zielort",
                                        variant: "outlined",
                                        "hide-details": "",
                                        density: "compact",
                                        clearable: true,
                                        "data-cy": "endLocationFilter"
                                    }, null, 8, ["modelValue", "items"])
                                ]),
                                [`header.startTimeFilter`]: _withCtx(({}) => [
                                    _createVNode(_component_v_select, {
                                        class: "pt-1 pb-1",
                                        modelValue: startTimeFilter.value,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((startTimeFilter).value = $event)),
                                        items: getStartTimeValues(),
                                        "item-title": (t) => _unref(Formatter).time(t),
                                        "item-value": (t) => t,
                                        label: "Startzeit",
                                        variant: "outlined",
                                        "hide-details": "",
                                        density: "compact",
                                        clearable: true,
                                        active: true,
                                        "data-cy": "startTimeFilter"
                                    }, null, 8, ["modelValue", "items", "item-title", "item-value"])
                                ]),
                                [`header.endTimeFilter`]: _withCtx(({}) => [
                                    _createVNode(_component_v_select, {
                                        class: "pt-1 pb-1",
                                        modelValue: endTimeFilter.value,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((endTimeFilter).value = $event)),
                                        items: getEndTimeValues(),
                                        "item-title": (t) => _unref(Formatter).time(t),
                                        "item-value": (t) => t,
                                        label: "Endzeit",
                                        variant: "outlined",
                                        "hide-details": "",
                                        density: "compact",
                                        clearable: true,
                                        active: true,
                                        "data-cy": "endTimeFilter"
                                    }, null, 8, ["modelValue", "items", "item-title", "item-value"])
                                ]),
                                item: _withCtx(({ item }) => [
                                    _createElementVNode("tr", {
                                        "data-cy": "reservationRow",
                                        class: "cursor-pointer",
                                        onClick: ($event) => (_ctx.$router.push({ name: 'admin-orders-edit', params: { id: item.orderId.toString() } }))
                                    }, [
                                        _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(Formatter).date(item.dateFrom)), 1),
                                        _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(Formatter).date(item.dateTo)), 1),
                                        _createElementVNode("td", _hoisted_5, _toDisplayString(item.customer), 1),
                                        _createElementVNode("td", _hoisted_6, _toDisplayString(item.internalRemarks), 1),
                                        _createElementVNode("td", _hoisted_7, _toDisplayString(item.productStartLocationName), 1),
                                        _createElementVNode("td", _hoisted_8, _toDisplayString(item.productEndLocationName), 1),
                                        _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(Formatter).time(item.startTime)), 1),
                                        _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(Formatter).time(item.endTime)), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getResourcesForList(), (resource, index) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: index,
                                                class: "px-4 text-start"
                                            }, _toDisplayString(findReservedQuantityForResource(resource, item)), 1));
                                        }), 128))
                                    ], 8, _hoisted_2)
                                ]),
                                [`tfoot`]: _withCtx(({ items }) => [
                                    (items.length > 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                            _cache[10] || (_cache[10] = _createElementVNode("th", null, null, -1)),
                                            _cache[11] || (_cache[11] = _createElementVNode("th", null, null, -1)),
                                            _cache[12] || (_cache[12] = _createElementVNode("th", null, null, -1)),
                                            _cache[13] || (_cache[13] = _createElementVNode("th", null, null, -1)),
                                            _cache[14] || (_cache[14] = _createElementVNode("th", null, null, -1)),
                                            _cache[15] || (_cache[15] = _createElementVNode("th", null, null, -1)),
                                            _cache[16] || (_cache[16] = _createElementVNode("th", null, null, -1)),
                                            _cache[17] || (_cache[17] = _createElementVNode("th", { class: "px-4 text-start" }, "Summe", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getResourcesForList(), (resource, index) => {
                                                return (_openBlock(), _createElementBlock("th", {
                                                    class: "px-4 text-start",
                                                    key: index
                                                }, _toDisplayString(getReservationsSum(resource, items)), 1));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1032, ["items", "headers"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
